import api from '@http/api';


class ComponentSolicitacaoServices {

    public async gerarExtrato(
    PerfilId: number,
    DataInicial: string,
    DataFinal: string,

  ) {
    return await api
      .post(
        `/api/Doacao/ExtratoDoacoesByPerfil?PerfilId=${PerfilId}&DataInicial=${DataInicial}&DataFinal=${DataFinal}`,
      )
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: null,
        };
      });
  }
}

export default ComponentSolicitacaoServices;
